import styled from 'styled-components';

export const AssessmentStandarContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  align-items: center;
  width: ${({ theme }) => theme.width.full};
  & .react-confirm-alert-overlay {
    z-index: 999;
    & img {
      object-fit: contain;
      max-width: 100%;
      max-height: calc(100dvh - 420px);
    }
  }
`;

export const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 100px);
  background-color: ${({ theme }) => theme.colors.white};
  width: ${({ theme }) => theme.width.full};
  top: 85px;
  position: absolute;
  padding-bottom: 85px;
`;

export const ScoreContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.m} 0;
`;

export const TextAreaLabel = styled.h3`
  font-weight: 400;
  font-size: 14px;
  color: #1f1f1f;
  -webkit-letter-spacing: 0;
  -moz-letter-spacing: 0;
  -ms-letter-spacing: 0;
  letter-spacing: 0;
  line-height: 18px;
  font-style: normal;
  margin-bottom: 6px;
`;

export const AssessedContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.m};
  border: 1px solid ${({ theme }) => theme.colorsInObjects.gray[600]};
  display: flex;
  align-items: center;
  border-radius: ${({ theme }) => theme.radius.s};
  gap: ${({ theme }) => theme.spacing.s};
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const SubTabContainer = styled.div`
`;

export const DatePickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s};
  margin: ${({ theme }) => theme.spacing.m} ${({ theme }) => theme.spacing.none};
`;
